// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"980px","desktopWidth":"1920px","root":"mainContent_root__p-Htv","shareButtonGroup":"mainContent_shareButtonGroup__2V_C3","innerHtml":"mainContent_innerHtml__2lJhT"};